import { __wbg___wbindgen_throw_be289d5034ed271b, __wbg_parse_9e3ea228dba1cc2a, __wbg_stringify_e4a940b133e6b7d8, __wbindgen_init_externref_table } from "./fuzzy_search_bg.js";
import wasmPath from "WASM_PATH";

const { memory, __wbg_airportindex_free, airportindex_clear, airportindex_new, airportindex_search, airportindex_set_items, search_airport, __wbindgen_free, __wbindgen_malloc, __wbindgen_realloc, __wbindgen_externrefs, __externref_drop_slice, __externref_table_alloc, __wbindgen_start } = await __turbopack_wasm__(wasmPath, () => wasm_d17c537353db074864657f4ca40d036f, {
    "./fuzzy_search_bg.js": {
        "__wbg___wbindgen_throw_be289d5034ed271b": __wbg___wbindgen_throw_be289d5034ed271b,
        "__wbg_parse_9e3ea228dba1cc2a": __wbg_parse_9e3ea228dba1cc2a,
        "__wbg_stringify_e4a940b133e6b7d8": __wbg_stringify_e4a940b133e6b7d8,
        "__wbindgen_init_externref_table": __wbindgen_init_externref_table,
    },
}
);

export { memory, __wbg_airportindex_free, airportindex_clear, airportindex_new, airportindex_search, airportindex_set_items, search_airport, __wbindgen_free, __wbindgen_malloc, __wbindgen_realloc, __wbindgen_externrefs, __externref_drop_slice, __externref_table_alloc, __wbindgen_start };
